import React from "react";

/* create text for pricing per month */
export function PricingMonth() {
  return (
    <span className="text-xl text-slate-500 flex flex-col justify-end">
      /mo
    </span>
  );
}
